import React from 'react'

export const ListingsNew = () => {
    return (
        'hello'
    )
}